import React, { useEffect } from "react";
import ProtectedRoute from "./ProtectedRoute";
import PaymentSuccess from "./PaymentSuccess";

// Handles the Stripe return. For the native iOS app (client=ios) it bounces to the
// rideburaq:// callback so ASWebAuthenticationSession closes; web renders PaymentSuccess.
const SuccessRoute = () => {
  const params = new URLSearchParams(window.location.search);
  const isIos = params.get("client") === "ios";

  useEffect(() => {
    if (isIos) {
      const sid = params.get("session_id");
      const target = params.get("cancelled")
        ? "rideburaq://cancel"
        : `rideburaq://checkout?session_id=${encodeURIComponent(sid || "")}`;
      window.location.replace(target);
    }
  }, []);

  if (isIos) {
    return (
      <div style={{ minHeight: "100vh", background: "#000", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "sans-serif" }}>
        Returning to the RideBuraq app…
      </div>
    );
  }

  return (
    <ProtectedRoute>
      <PaymentSuccess />
    </ProtectedRoute>
  );
};

export default SuccessRoute;
